import { forwardRef } from '@chakra-ui/react';
import moment from 'moment';

import { type FieldSuggestion } from '@frontend/api';
import {
  Flex,
  type FlexProps,
  Text,
  Button,
  DatePickerProps,
} from '@frontend/components';
import { AssistanceIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

export interface SuggestionFooterProps extends FlexProps {
  suggestion: FieldSuggestion;
  suggestionIsAccepted: boolean;
  suggestionIsRejected: boolean;
  format: DatePickerProps['format'];
  onAcceptSuggestion: () => void;
}

export const SuggestionFooter = forwardRef<SuggestionFooterProps, 'div'>(
  (
    {
      suggestion,
      suggestionIsAccepted,
      suggestionIsRejected,
      onAcceptSuggestion,
      format,
      ...restProps
    },
    ref,
  ) => {
    return (
      <Flex
        ref={ref}
        onMouseDown={(e) => e.stopPropagation()} // HACK: work around antd-picker issue
        px={1.5}
        py={1}
        bg="interaction.surfaceSuggestionHover"
        justifyContent="space-between"
        alignItems="center"
        {...restProps}
      >
        <Flex gap={0.75} alignItems="center">
          <AssistanceIcon boxSize={2.25} color="interaction.suggestion" />
          <Text fontWeight="medium">
            {moment(suggestion.suggestion).format(format)}
          </Text>
          <Text>
            <Text as="span" color="feature.secondary" size="sm">
              From{' '}
            </Text>
            <Text as="span" color="interaction.suggestion" size="sm">
              {suggestion.sourceName}
            </Text>
          </Text>
        </Flex>
        <Button
          onClick={onAcceptSuggestion}
          variant={
            suggestionIsAccepted || suggestionIsRejected
              ? 'secondary'
              : 'primary'
          }
          colorScheme="suggestion"
          size="sm"
        >
          Apply
        </Button>
      </Flex>
    );
  },
);
